<template>
  <div class="carousel-cell">
    <span class="attendances__month">
      <span>{{ formatMonthName }}</span>
      <transition name="accordion" mode="out-in">
        <span class="attendances__month-collapse" @click="openAccordion" :key="animate">
          <span class="attendances__month-accordion">{{ showAccordion }}</span>
          <img v-if="isClosed" src="@/assets/images/icons/down-arrow.svg" alt="Accordion" />
          <img v-if="isClosed === false" src="@/assets/images/icons/up-arrow.svg" alt="Accordion" />
        </span>
      </transition>
    </span>
    <div class="attendances__list flex-col flex">
      <div v-for="attendance in attendances" :key="attendance.id">
        <div class="attendances__item">
          <span
            class="attendances__item__day"
            :class="{
            'text-present': attendance.status === 1,
            'text-present-late': attendance.status === 2,
            'text-present-no': attendance.status === 3,
            }"
            >{{ formatShort(attendance) }}</span
          >
          <span class="flex-1">
            {{ formatDay(attendance) }}
            <span v-if="attendance.lesson.isWorkshop" class="workshop-label">(warsztaty)</span>
          </span>
          <div class="attendances__item__status">
            <img
              v-if="attendance.status !== 3 && attendance.book === 2"
              src="@/assets/images/statuses/book.svg"
              alt="Status"
            />
            <img
              class="attendances__status-icon attendances__status-icon--tick"
              v-if="attendance.status === 1"
              src="@/assets/images/statuses/tick.svg"
              alt="Status"
            />
            <img
              class="attendances__status-icon attendances__status-icon--clock"
              v-if="attendance.status === 2"
              src="@/assets/images/statuses/clock.svg"
              alt="Status"
            />
            <img
              class="attendances__status-icon attendances__status-icon--cross"
              v-if="attendance.status === 3"
              src="@/assets/images/statuses/cross.svg"
              alt="Status"
            />
          </div>
        </div>
        <transition name="accordion" mode="out-in">
        <div
          class="attendances__accordion"
          :class="{
          'hidden': isClosed,
          'text-black' : attendance.status === 0,
          'text-white' : attendance.status !== 0,
          'bg-present': attendance.status === 1,
          'bg-present-late': attendance.status === 2,
          'bg-present-no': attendance.status === 3,
          }"
          :key="animate"
        >
          <span v-if="!attendance.lesson && attendance.lesson.subject">
            {{ $t('dashboard.subject_not_found') }}
          </span>
          <span v-else-if="!attendance.lesson.subject">
            <span class="font-semibold">{{ $t('dashboard.subject') }}:</span>
            {{ $t('dashboard.attendances_subject_empty') }}
          </span>
          <span v-else>
            <span class="font-semibold">{{ $t('dashboard.subject') }}:</span>
            {{ attendance.lesson.subject }}
          </span>
        </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {
      isClosed: false,
      animate: false,
    };
  },
  props: {
    attendances: Array,
    monthName: String,
  },

  computed: {
    formatMonthName() {
      return moment(this.monthName, 'YYYY-MM').format('MMMM');
    },
    showAccordion() {
      if (this.isClosed) {
        return this.$t('dashboard.subjects_show');
      }
      return this.$t('dashboard.subjects_hide');
    },
  },

  methods: {
    formatShort(attendance) {
      return moment(attendance.lesson.date).format('DD.MM');
    },

    formatDay(attendance) {
      return moment(attendance.lesson.date).format('dddd');
    },

    openAccordion() {
      this.isClosed = !this.isClosed;
      this.animate = !this.animate;
    },
  },

  mounted() {
    this.isClosed = false;
  },
};
</script>

<style lang="scss" scoped>
.attendances__month {
  @apply flex w-full flex-row justify-between text-center text-sm mb-6;
  @media screen and (min-width: 992px) {
    @apply flex-col text-left mb-4 text-2xl;
  }
  @media screen and (min-width: 1050px) {
    @apply flex-row;
  }
  @media screen and (min-width: 1500px) {
    @apply flex-col;
  }
  @media screen and (min-width: 1700px) {
    @apply flex-row;
  }
  &-collapse {
    @apply flex justify-end items-end;
    @media screen and (min-width: 992px) and (max-width: 1049px) {
      @apply mt-2;
    }
    @media screen and (min-width: 1500px) and (max-width: 1699px) {
      @apply mt-2;
    }
  }
  &-accordion {
    @apply text-sm;
  }
  img {
    @apply mx-1;
    width: 10px;
  }
}

.attendances__list {
  @apply bg-white w-full rounded-lg overflow-hidden mt-0;
}

.attendances__item {
  @apply flex justify-start items-center py-3 px-3;
  flex-wrap: wrap;
  &__day {
    @apply font-semibold pr-2;
  }
  &__status {
    @apply flex justify-center items-center text-white
    rounded text-center;
    img {
      width: 32px;
      height: 32px;
      margin-right: 6px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}

.attendances__status-icon {
  border-radius: 3px;
  &--tick {
    background-color: #3ea447;
  }
  &--clock {
    background-color: #b7d257;
  }
  &--cross {
    background-color: #ef4024;
  }
}

.workshop-label {
  @apply text-grey-3;
  font-weight: normal;
}

.attendances__accordion {
  @apply text-sm p-3;
}

.accordion-enter-active {
  transition: opacity 0.2s ease;
}

.accordion-leave-active {
  transition: opacity 0.2s ease;
}

.accordion-enter,
.accordion-leave-to {
  opacity: 0.4;
}
</style>
